import { render } from "./TheLanguage.vue?vue&type=template&id=16258590&scoped=true&ts=true&lang=html"
import script from "./TheLanguage.vue?vue&type=script&lang=ts"
export * from "./TheLanguage.vue?vue&type=script&lang=ts"

import "./TheLanguage.vue?vue&type=style&index=0&id=16258590&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16258590"]])

export default __exports__